document.querySelectorAll('[data-sidebar-link]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelectorAll('[data-sidebar-link]').forEach(anchor => {
      anchor.classList.remove('active');
    });
    this.classList.add('active');
    document.querySelector(this.getAttribute('data-sidebar-link')).scrollIntoView({
        behavior: 'smooth'
    });
  });
});

const selectBox = document.querySelector('#sidebarSelect');
selectBox.addEventListener('change', function (e) {
  let selectedOption = selectBox.options[selectBox.selectedIndex];
  document.querySelector(selectedOption.getAttribute('data-sidebar-option')).scrollIntoView({
      behavior: 'smooth'
  });
});
